<template>
    <div class="py-5">
        <b-card style="max-width: 600px" class="mx-auto text-left px-3 py-3">
            <h5 class="pb-3">Log In</h5>
            <b-form-group   label="Email"
                            :state="errors.has('email')? false : null"
							:invalid-feedback="errors.first('email')"
            >
                <b-form-input 	name="email" 
								v-model="email" 
								@keyup.enter.native="login" 
								v-validate="'required|email'"
								:state="errors.has('email')? false : null"
								autofocus 
				/>
            </b-form-group>

            <b-form-group   label="Password"
                            :state="errors.has('password')? false : null"
							:invalid-feedback="errors.first('password')"
            >
                <b-form-input 	name="password"
								type="password"
								v-model="password"
								@keyup.enter.native="login" 
								v-validate="'required|min:5'"
								:state="errors.has('password')? false : null"
				/>
            </b-form-group>

            <div class="text-right">
                <b-btn variant="primary" class="mr-2" @click="login">Log In</b-btn>
                <b-btn variant="secondary" to="/register">Register</b-btn>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: '',
            password: ''
        }
    },

    methods: {
		async login() {
			if (!await this.$validator.validate()) {
				return;
			}

		   	this.$app.authenticate({
				strategy: 'local',	
				email: this.email,
				password: this.password
			})
				.then(response => {
					console.log(response);
					this.$router.push({ name: 'Dashboard' });
				})
				.catch(error => alert(error));
		},

	}
}
</script>

